import React from 'react';

export const ChildSupportTextMid = () => {
  return (
    <>
      <p>Що входить в роботу:</p>
      <p>✔️консультації на всьому етапі справи;</p>
      <p>✔️підготовка позовної заяви, або заяви про видачу судового наказу;</p>
      <p>✔️формування справи для подачі в суд;</p>
      <p>✔️подача документів в суд;</p>
      <p>✔️моніторінг справи в суді;</p>
      <p>
        ✔️інструкція, як отримати рішення суду і як передати його у відділ
        державної служби для примусового стягнення аліментів.
      </p>
    </>
  );
};
